
import TitleService from 'title-service';
import './ProfileEditItem.scss';
export default function ProfileEditItem(props: { profileName: string, profileImage: string, onClick: () => void }) {
    return (
        <div className="profile-avatar-appear-done profile-avatar-enter-done " style={{ "textAlign": "center" }}>
            <div aria-label="" data-testid="profile-avatar-3" role="button" tabIndex={0} onClick={() => {
                props.onClick();
            }} className="sc-kLIISr sc-iGPElx jZNVMe">
                <div className="sc-dliRfk sc-jXQZqI dnAhBg profile-avatar" style={{
                    background: `url(${props.profileImage}) 0% 0% / contain no-repeat`
                }}>

                    <div aria-label={TitleService(`Edit ${props.profileName}'s profile.`)} name="edit" className="sc-etwtAo JfzBn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                            <g fill="none" fillRule="evenodd">
                                <path d="M36 36H0V0h36z" />
                                <circle cx="18" cy="17.75" r="13" fill="#F9F9F9" />
                                <path fill="#000" d="M20.44 13.236l-1.045 1.044 2.074 2.074 1.045-1.044-2.074-2.074zm-1.392 1.391l-4.655 4.655 2.074 2.074 4.655-4.655-2.074-2.074zm-4.971 5.033l-.591 2.604 2.604-.591-2.013-2.013z" />
                            </g>
                        </svg>
                    </div>      </div>
                <h3 className="margin--top-6 text--center text-color--primary">{props.profileName}</h3>
            </div>
        </div>
    );
}
